<template>
  <div>
  
  
  
   <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;cursor:pointer;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
  
    <div  v-if="task_id!=0" class="text-center"  style="margin-top:30px;margin-bottom:50px;max-width:300px;margin-left:auto;margin-right:auto;">
  	   <p-button type="default"  block round  @click.prevent="goToTask">View Task & Request</p-button> 
    </div>
  
  
  
 <h4 v-if="createForm" slot="header" class="card-title" style="font-weight:bold;">
    Create New Billing
    </h4>
     <h4 v-else slot="header" class="card-title" style="font-weight:bold;">
     Edit Billing #{{model.id}}
    </h4>
  
 <card class="form-horizontal">
   
    

    <div class="row" style="text-align:left;">
      <label class="col-sm-2 col-form-label">Title</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="title"
                  v-validate="modelValidations.Title"
                  :error="getError('Title')"
                  v-model="model.title">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

    <div  v-if="model.is_multi_item == 0" class="row">
      <label class="col-sm-2 col-form-label">Description</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="description"
                  v-validate="modelValidations.description"
                  :error="getError('description')"
                  v-model="model.description">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code>Optional</code>
      </div>
    </div>
    
    
    
     <div v-if="model.is_multi_item == 1" class="row" style="margin-top:30px;margin-bottom:30px;">
      <label class="col-sm-2 col-form-label">Invoice Items</label>
      <div class="col-sm-7">
      	<div>
      	{{model.description}} - <strong> {{model.amount_str}}</strong>
      	
      	</div>
       	<div v-for="ii in model.invoice_items">
       	{{ii.title}} - <strong> {{ii.amount_str}} </strong>
       	</div>
       
        <fg-input type="text"
                  name="description"
                  style="display:none;"
                  v-validate="modelValidations.description"
                  :error="getError('description')"
                  v-model="model.description">
        </fg-input>
        
       	
       
      </div>
      <div class="col-sm-3 label-on-right">
        <code>Optional</code>
      </div>
    </div>
    
    
    
    
    
    <div v-if="model.is_multi_item == 0" class="row">
      <label class="col-sm-2 col-form-label">Amount</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="amount"
             	  style="width:200px"
                  v-validate="modelValidations.amount"
                  :error="getError('amount')"
                  v-model="model.amount">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
    <div v-if="model.is_multi_item == 1" class="row">
      <label class="col-sm-2 col-form-label">Total Amount</label>
      <div class="col-sm-7">
     		<div style="padding-bottom:20px;padding-top:10px;">  {{model.total_amount_str}}</div>
     		<fg-input type="text"
                  name="amount"
             	  style="width:200px;display:none;"
                  v-validate="modelValidations.amount"
                  :error="getError('amount')"
                  v-model="model.amount">
      		  </fg-input>
     
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Currency</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder=""
                             v-model="model.currency">
                    <el-option v-for="option in selects.currencies"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    

    
     <div class="row">
      <label class="col-sm-2 col-form-label">Due Date</label>
      <div class="col-sm-7">
        <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="model.deadline" type="date" placeholder="Select A Date"
              	name ="deadline"
              	:error="getError('deadline')"
              	v-bind:class="{ field_error_cs: errors.has('deadline') }"
              	 v-validate="modelValidations.deadline" 
              >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

 

	
	  <div class="row">
      <label class="col-sm-2 col-form-label">Notes</label>
      <div class="col-sm-7">
       <textarea 
        		 cols="45" rows="10"
                  name="new_reso_item"
                  v-model="model.notes">
       	    </textarea>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>


	
   

  </card>
  
  <card>
	 <div class="row">
      <label class="col-sm-2 col-form-label">Payment Status</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder=""
                             v-model="model.status">
                    <el-option v-for="option in selects.payment_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Transaction Reference Code</label>
      <div class="col-sm-7">
   		<div v-if="model.reference_id" style="padding-top:5px;padding-bottom:10px;"> {{model.reference_id}}</div>
   		<div v-else>-</div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
   </card> 
        
        
 <div slot="footer" class="text-center" >
      <p-button v-if="createForm"  type="info" @click.prevent="submitNewRecurringBillForm">Submit New Recurring Bill</p-button>
      <p-button v-else  type="info" @click.prevent="editInvoice">Update Invoice </p-button>
    </div>
   


  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     	
    				
     
       if(this.$route.params.iid!=0){
     		this.createForm = false;
     		
     		let uri = this.$base_url+'/api/v1/accounting/get/invoice/'+ this.$route.params.iid;
   
			 ApiService.get(uri).then(response => {
				
				this.model = response.data.invoice;
				//this.model.due_date = response.data.invoice.deadline;
				swal.close();
				
			
			})

       }
       
       if(this.$route.params.eid!=0){
     
			let uri = this.$base_url+'/api/v1/entities/simple/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				this.coy = response.data.entity;
			
			})
      	}//get connected entity info
      
     	 	
      
    },
    
     
    data () {
      return {
        coy:[],
        variables:[],
    	eid: this.$route.params.eid,
    	oid: this.$route.params.oid,
    	task_id:this.$route.params.tid,
    	createForm: true,
    	loadCommon: false,
    	loadInfo: false,
    	
    	displayCompanyForm: false,
        model: {
          title: 'Annual Subscription Fee',
          description: '',
          amount: '',
		  currency:'SGD',
		  category:1,
		  due_date:'',

        },
        modelValidations: {
          title: {
          },
          description: {
          },
          amount: {
            required: true,
            decimal:true,
          },
          due_date: {
          	required: true,
          },
         
          
        },
        
        selects: {
          currencies: [
            {value: "SGD", label: 'SGD'},
		   ],
		   payment_status: [
            {value: 1, label: 'Not Paid'},
            {value: 2, label: 'Paid'},
            {value: 3, label: 'Cancelled'},
            {value: 4, label: 'Refunded'},
		   ],
		  billing_cycle:[
            {value: 1, label: 'Annually'},
            {value: 2, label: 'Monthly'},
		   ],
		   category:[
            {value: 1, label: 'Annual Subscription Fee'},
		   ] 
        },
      }
    },
    methods:{
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    goToTask(){
       		this.$router.push( '/edit-task/'+ this.task_id + '/entity/'+ this.$route.params.eid)
       },
       displayErrorMessage(msg){
        		swal({
					  title: 'Error!',
					  text: msg,
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 	})
        
        
        
        },
    	onIsCompanyRepChange(event){
       		if(this.model.is_company == 1){

       			this.displayCompanyForm = true;
       		}
       		else{
       			this.displayCompanyForm = false;
       		}
       
       },
 
       getError(fieldName) {
        return this.errors.first(fieldName)
      },
      submitNewRecurringBillForm() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/accounting/create/recurring_bill/'+ this.$route.params.eid;
      		ApiService.post(uri, this.model).then(response => {
      				this.$router.push( '/view-entity/'+ this.$route.params.eid);
         		
     		 })
  		  }
        
         
        })
      },///end validate+create
      editInvoice() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
  		  	this.model.due_date = this.model.deadline;
  		  	
    		let uri = this.$base_url+'/api/v1/accounting/update/invoice/'+this.$route.params.iid;
      		ApiService.post(uri, this.model).then(response => {
         			this.$router.push( '/view-entity/'+ this.$route.params.eid);
         			
     		 })
  		  }
        
         
        })
      },///end validate+edit
      
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


